import { render, staticRenderFns } from "./TopupManagement.vue?vue&type=template&id=4ed08fec&scoped=true&"
import script from "./TopupManagement.vue?vue&type=script&lang=js&"
export * from "./TopupManagement.vue?vue&type=script&lang=js&"
import style0 from "./TopupManagement.vue?vue&type=style&index=0&id=4ed08fec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed08fec",
  null
  
)

export default component.exports